<template>
    <div class="order-page-container">
        <!-- 页面标题 -->


        <!-- 下单类型切换 -->
        <div class="order-type-tabs">
            <el-radio-group v-model="activeType" @change="handleTypeChange">
                <el-radio-button label="finished">成品菜</el-radio-button>
                <el-radio-button label="semi">半成品</el-radio-button>
            </el-radio-group>
        </div>

        <!-- 下单表单 -->
        <div class="order-form-card">
            <!-- 半成品专用：功能间选择 -->
            <el-form-item label="目标功能间" v-if="activeType === 'semi'" class="workshop-selector">
                <el-select v-model="selectedWorkshop" placeholder="请选择功能间" style="width: 220px" clearable>
                    <el-option v-for="workshop in workshopList" :key="workshop.id" :label="workshop.name"
                        :value="workshop.id"></el-option>
                </el-select>
            </el-form-item>

            <!-- 商品列表 -->
            <div class="product-list">
                <div class="list-header">
                    <div class="header-item" style="width: 30%">菜品名称</div>
                    <div class="header-item" style="width: 15%">规格</div>
                    <div class="header-item" style="width: 15%">单位</div>
                    <div class="header-item" style="width: 15%">单价(元)</div>
                    <div class="header-item" style="width: 15%">数量</div>
                    <div class="header-item" style="width: 10%">操作</div>
                </div>

                <div class="product-item" v-for="product in filteredProducts" :key="product.id">
                    <div class="item-content" style="width: 30%">
                        <div class="product-name">{{ product.name }}</div>
                        <div class="product-code">{{ product.code }}</div>
                    </div>
                    <div class="item-content" style="width: 15%">{{ product.spec }}</div>
                    <div class="item-content" style="width: 15%">{{ product.unit }}</div>
                    <div class="item-content" style="width: 15%">{{ product.price.toFixed(2) }}</div>
                    <div class="item-content" style="width: 15%">
                        <el-input-number v-model="product.quantity" :min="0" :step="1"
                            @change="handleQuantityChange(product)" size="small"></el-input-number>
                    </div>
                    <div class="item-content" style="width: 10%">
                        <el-button type="text" icon="el-icon-delete" class="delete-btn"
                            @click="removeProduct(product.id)"></el-button>
                    </div>
                </div>

                <!-- 空状态 -->
                <div class="empty-state" v-if="filteredProducts.length === 0">
                    <el-empty description="暂无菜品数据，请切换类型或添加菜品" :image-size="100"></el-empty>
                </div>
            </div>

            <!-- 添加菜品按钮 -->
            <el-button type="primary" icon="el-icon-plus" class="add-product-btn" @click="showProductDialog = true">
                添加菜品
            </el-button>

            <!-- 订单汇总 -->
            <div class="order-summary">
                <div class="summary-item">
                    <span>总数量：</span>
                    <span class="value">{{ totalQuantity }}</span>
                </div>
                <div class="summary-item">
                    <span>总金额：</span>
                    <span class="value">¥{{ totalAmount.toFixed(2) }}</span>
                </div>
                <div class="summary-item">
                    <span>菜品总数：</span>
                    <span class="value">{{ filteredProducts.length }} 种</span>
                </div>
            </div>

            <!-- 备注信息 -->
            <el-form-item label="订单备注" class="order-remark">
                <el-input v-model="orderRemark" type="textarea" rows="3" placeholder="请输入订单备注信息（如特殊加工要求等）"></el-input>
            </el-form-item>

            <!-- 操作按钮 -->
            <div class="order-actions">
                <el-button @click="resetOrder">重置</el-button>
                <el-button type="primary" @click="submitOrder" :disabled="!canSubmit">提交订单</el-button>
            </div>
        </div>

        <!-- 菜品选择弹窗 -->
        <el-dialog title="选择菜品" :visible.sync="showProductDialog" width="800px" :close-on-click-modal="false"
            :z-index="3000" append-to-body>
            <el-input v-model="productSearch" placeholder="搜索菜品名称或编码" prefix-icon="el-icon-search" clearable
                style="margin-bottom: 15px"></el-input>

            <el-table :data="searchProducts" border style="width: 100%" @selection-change="handleProductSelection">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="code" label="编码" width="120"></el-table-column>
                <el-table-column prop="name" label="菜品名称" width="200"></el-table-column>
                <el-table-column prop="spec" label="规格"></el-table-column>
                <el-table-column prop="unit" label="单位" width="80"></el-table-column>
                <el-table-column prop="price" label="单价(元)" width="100" align="right">
                    <template #default="scope">{{ scope.row.price.toFixed(2) }}</template>
                </el-table-column>
                <el-table-column prop="category" label="分类" width="120"></el-table-column>
            </el-table>

            <div slot="footer">
                <el-button @click="showProductDialog = false">取消</el-button>
                <el-button type="primary" @click="confirmAddProducts">确认添加</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'DishOrderPage',
    data() {
        return {
            // 订单基础信息
            orderDate: new Date(),
            orderNo: '',
            orderRemark: '',
            activeType: 'finished', // finished:成品菜 semi:半成品

            // 功能间列表（半成品目标地址）
            workshopList: [
                { id: 1, name: '切配间' },
                { id: 2, name: '热厨间' },
                { id: 3, name: '冷菜间' },
                { id: 4, name: '面点间' },
                { id: 5, name: '备餐间' }
            ],
            selectedWorkshop: '',

            // 菜品数据
            allProducts: [
                // 成品菜
                {
                    id: 1,
                    type: 'finished',
                    code: 'FIN001',
                    name: '宫保鸡丁',
                    spec: '200g/份',
                    unit: '份',
                    price: 38,
                    category: '热菜',
                    quantity: 0
                },
                {
                    id: 2,
                    type: 'finished',
                    code: 'FIN002',
                    name: '麻婆豆腐',
                    spec: '150g/份',
                    unit: '份',
                    price: 18,
                    category: '热菜',
                    quantity: 0
                },
                {
                    id: 3,
                    type: 'finished',
                    code: 'FIN003',
                    name: '夫妻肺片',
                    spec: '120g/份',
                    unit: '份',
                    price: 28,
                    category: '冷菜',
                    quantity: 0
                },
                // 半成品
                {
                    id: 101,
                    type: 'semi',
                    code: 'SEM001',
                    name: '腌制鸡胸肉',
                    spec: '500g/袋',
                    unit: '袋',
                    price: 45,
                    category: '肉品',
                    quantity: 0
                },
                {
                    id: 102,
                    type: 'semi',
                    code: 'SEM002',
                    name: '切配青菜',
                    spec: '300g/盒',
                    unit: '盒',
                    price: 8,
                    category: '蔬菜',
                    quantity: 0
                },
                {
                    id: 103,
                    type: 'semi',
                    code: 'SEM003',
                    name: '预炸薯条',
                    spec: '400g/袋',
                    unit: '袋',
                    price: 15,
                    category: '油炸类',
                    quantity: 0
                }
            ],
            selectedProducts: [], // 当前已选菜品
            productSearch: '',
            showProductDialog: false,
            selectedRows: [] // 弹窗中选中的菜品
        };
    },
    computed: {
        // 根据当前类型过滤菜品
        filteredProducts() {
            return this.selectedProducts.filter(item => item.type === this.activeType);
        },
        // 弹窗中可选择的菜品（排除已添加的）
        searchProducts() {
            const unselected = this.allProducts.filter(
                item => item.type === this.activeType &&
                    !this.selectedProducts.some(p => p.id === item.id)
            );
            // 搜索过滤
            if (this.productSearch) {
                const keyword = this.productSearch.toLowerCase();
                return unselected.filter(
                    item => item.name.toLowerCase().includes(keyword) ||
                        item.code.toLowerCase().includes(keyword)
                );
            }
            return unselected;
        },
        // 计算总数量
        totalQuantity() {
            return this.filteredProducts.reduce((sum, item) => sum + item.quantity, 0);
        },
        // 计算总金额
        totalAmount() {
            return this.filteredProducts.reduce((sum, item) => sum + (item.quantity * item.price), 0);
        },
        // 是否可以提交订单
        canSubmit() {
            // 成品菜：至少有一种菜品且数量>0
            // 半成品：额外需要选择功能间
            if (this.activeType === 'semi' && !this.selectedWorkshop) return false;
            return this.filteredProducts.some(item => item.quantity > 0);
        }
    },
    mounted() {
        // 生成订单号
        this.generateOrderNo();
    },
    methods: {
        // 生成订单号（日期+随机数）
        generateOrderNo() {
            const date = new Date();
            const y = date.getFullYear();
            const m = (date.getMonth() + 1).toString().padStart(2, '0');
            const d = date.getDate().toString().padStart(2, '0');
            const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
            this.orderNo = `ORD${y}${m}${d}${random}`;
        },

        // 切换订单类型
        handleTypeChange(type) {
            this.activeType = type;
        },

        // 数量变化
        handleQuantityChange(product) {
            // 确保数量不为负数
            if (product.quantity < 0) product.quantity = 0;
        },

        // 移除菜品
        removeProduct(id) {
            this.selectedProducts = this.selectedProducts.filter(item => item.id !== id);
        },

        // 处理弹窗中选择的菜品
        handleProductSelection(rows) {
            this.selectedRows = rows;
        },

        // 确认添加菜品
        confirmAddProducts() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请选择需要添加的菜品');
                return;
            }
            // 复制选中的菜品并初始化数量为0
            const newProducts = this.selectedRows.map(item => ({ ...item, quantity: 0 }));
            this.selectedProducts = [...this.selectedProducts, ...newProducts];
            this.showProductDialog = false;
            this.selectedRows = [];
            this.productSearch = '';
        },

        // 重置订单
        resetOrder() {
            this.selectedProducts = [];
            this.orderRemark = '';
            this.selectedWorkshop = '';
            this.orderDate = new Date();
            this.generateOrderNo();
        },

        // 提交订单
        submitOrder() {
            // 构建订单数据
            const orderData = {
                orderNo: this.orderNo,
                orderDate: this.orderDate,
                type: this.activeType,
                workshopId: this.activeType === 'semi' ? this.selectedWorkshop : null,
                workshopName: this.activeType === 'semi'
                    ? this.workshopList.find(w => w.id === this.selectedWorkshop)?.name
                    : null,
                remark: this.orderRemark,
                items: this.filteredProducts.filter(item => item.quantity > 0).map(item => ({
                    productId: item.id,
                    productCode: item.code,
                    productName: item.name,
                    spec: item.spec,
                    unit: item.unit,
                    price: item.price,
                    quantity: item.quantity,
                    amount: item.price * item.quantity
                })),
                totalQuantity: this.totalQuantity,
                totalAmount: this.totalAmount
            };

            // 模拟提交
            console.log('提交订单数据:', orderData);
            this.$message.success('订单提交成功！');
            this.resetOrder();
        }
    }
};
</script>

<style lang="scss" scoped>
.order-page-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h2 {
        font-size: 18px;
        font-weight: 500;
        color: #1f2937;
        margin: 0;
    }

    .order-info {
        display: flex;
        align-items: center;
    }
}

.order-type-tabs {
    background-color: #fff;
    padding: 10px 20px;
    border-radius: 6px;
    margin-bottom: 20px;
}

.order-form-card {
    background-color: #fff;
    border-radius: 6px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.workshop-selector {
    margin-bottom: 20px;
}

.product-list {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    margin-bottom: 20px;
}

.list-header {
    display: flex;
    background-color: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    padding: 12px 20px;
    font-weight: 500;
    color: #4b5563;
}

.header-item {
    text-align: left;
}

.product-item {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    border-bottom: 1px solid #f3f4f6;

    &:last-child {
        border-bottom: none;
    }
}

.item-content {
    display: flex;
    align-items: center;
    color: #374151;

    &:first-child {
        .product-name {
            font-weight: 500;
            margin-bottom: 4px;
        }

        .product-code {
            font-size: 12px;
            color: #6b7280;
        }
    }
}

.delete-btn {
    color: #f56c6c;

    &:hover {
        color: #e34d4d;
    }
}

.empty-state {
    padding: 60px 0;
    text-align: center;
}

.add-product-btn {
    margin-bottom: 30px;
}

.order-summary {
    display: flex;
    justify-content: flex-end;
    gap: 30px;
    margin-bottom: 30px;
    padding-right: 20px;

    .summary-item {
        color: #4b5563;

        .value {
            font-weight: 500;
            color: #1f2937;
            margin-left: 6px;
        }
    }
}

.order-remark {
    margin-bottom: 20px;
}

.order-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
}
</style>